import { connect } from 'react-redux';
import FilterSideBar from './FilterSideBar';
import { closeFilterSidebar } from '../../../../redux/actions/filters';

const mapStateToProps = (state, props) => ({
  collapsed: !state.sidebar.advancedFilterMenuOpen,
});

const mapDispatchToProps = {
  closeFilterSidebar,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilterSideBar);
